/* eslint-disable import/prefer-default-export */
import { useContext } from "react";
import { SideMenuContext } from "./SideMenuContext";

export const useSideMenuContext = () => useContext(SideMenuContext);
